<script setup lang="ts">
import Breadcrumb from '@/components/ui/Breadcrumb.vue'

interface BreadcrumbLayoutProps {
  /** Custom container class */
  containerClass?: string
  /** Custom breadcrumb props */
  breadcrumbProps?: Record<string, unknown>
  /** Whether to show breadcrumbs */
  show?: boolean
  /** Custom background */
  background?: string
  /** Custom padding */
  padding?: string
  /** Shadow variant */
  shadow?: 'none' | 'sm' | 'md' | 'lg'
}

const props = defineProps<BreadcrumbLayoutProps>()

const {
  containerClass = 'breadcrumb-layout',
  breadcrumbProps = {},
  show = true,
  background = 'transparent',
  padding = '0 1.5rem',
  shadow = 'none',
} = props
</script>

<template>
  <div
    v-if="show && $route.name !== 'login' && $route.name !== 'signup' && $route.name !== 'forgot-password' && $route.name !== 'reset-password' && $route.name !== 'not-found' && $route.name !== 'home'"
    :class="[
      containerClass,
      'breadcrumb-layout',
      'container'
    ]"
    :style="{
      backgroundColor: background,
      padding: padding,
      boxShadow: shadow !== 'none' ? shadow : undefined,
    }"
    aria-label="Page breadcrumb navigation"
  >
    <div class="container-fluid px-0">
      <Breadcrumb v-bind="breadcrumbProps" />
    </div>
  </div>
</template>

<style scoped>
.breadcrumb-layout {
  position: relative;
  z-index: 10;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.breadcrumb-layout .breadcrumb-nav {
  padding: 0.5rem 0;
}

/* Shadow variants */
.breadcrumb-layout[style*="sm"] {
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.breadcrumb-layout[style*="md"] {
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
}

.breadcrumb-layout[style*="lg"] {
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
}

/* Background variants */
.breadcrumb-layout[style*="light"] {
  background-color: #f8fafc;
}

.breadcrumb-layout[style*="white"] {
  background-color: #ffffff;
}

/* Container fluid override for breadcrumb layout */
.breadcrumb-layout .container-fluid {
  max-width: 1440px;
  margin: 0 auto;
}

/* Print styles */
@media print {
  .breadcrumb-layout {
    display: none;
  }
}

/* RTL support */
[dir="rtl"] .breadcrumb-layout .container-fluid {
  padding-right: 0;
  padding-left: 0;
}
</style>